<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col sm>
        <b-card :title="$t('general.general')">

          <fields ungrouped/>
        </b-card>
      </b-col>
    </b-row>
    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import {ResourceFormMixin} from 'stylemix-vue-admin'
import VehicleTypeApi from './Api'

export default {
  name: 'VehicleTypeForm',

  mixins: [ResourceFormMixin],
  props: {

  },

  data() {
    return {
      base: 'vehicle-types',
    }
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    api() {
      return new VehicleTypeApi()
    },

    submit() {
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },

  },
}
</script>
